export const GET_LOGIN_RESPONSE = "GET_LOGIN_RESPONSE";
